/**
 * @generated SignedSource<<f0ac77edec1a22245f1cd8c2369eb82c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FixSageSyncAnalysisIssuesInput = {
  companyId?: number | null;
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type fixSageSyncAnalysisIssuesMutation$variables = {
  input: FixSageSyncAnalysisIssuesInput;
};
export type fixSageSyncAnalysisIssuesMutation$data = {
  readonly fixSageSyncAnalysisIssues: {
    readonly ids: ReadonlyArray<string | null> | null;
  } | null;
};
export type fixSageSyncAnalysisIssuesMutation = {
  variables: fixSageSyncAnalysisIssuesMutation$variables;
  response: fixSageSyncAnalysisIssuesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FixSageSyncAnalysisIssuesPayload",
    "kind": "LinkedField",
    "name": "fixSageSyncAnalysisIssues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fixSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fixSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "564f6c839a285ef34dc6b85021c75af1",
    "id": null,
    "metadata": {},
    "name": "fixSageSyncAnalysisIssuesMutation",
    "operationKind": "mutation",
    "text": "mutation fixSageSyncAnalysisIssuesMutation(\n  $input: FixSageSyncAnalysisIssuesInput!\n) {\n  fixSageSyncAnalysisIssues(input: $input) {\n    ids\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbdbcc7e965c2b68d08905946e79db44";

export default node;
